import React from 'react';
import { Button, ButtonGroup, Typography } from "@mui/material";
import './UnitToggle.css';

const UnitToggle = React.memo(({ unit, onToggle }) => {
  return (
    <ButtonGroup
      variant="contained"
      disableElevation
      sx={{ 
        height: '42px',
        '& .MuiButton-root': {
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
          backgroundColor: 'white',
          color: 'black',
          padding: '7.5px 15px',
          minWidth: 'auto',
          border: 'none',
          borderRadius: 0,
          '&:first-of-type': {
            borderTopLeftRadius: '15px',
            borderBottomLeftRadius: '15px',
          },
          '&:last-of-type': {
            borderTopRightRadius: '15px',
            borderBottomRightRadius: '15px',
          },
          '&:hover': {
            backgroundColor: '#f5f5f5',
            border: 'none',
          },
          '&.active': {
            backgroundColor: '#326038',
            color: 'white',
            border: 'none',
          }
        }
      }}
    >
      <Button 
        className={unit === "meters" ? "active" : ""}
        onClick={() => onToggle("meters")}
      >
        <Typography 
          style={{
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: '25px',
            whiteSpace: 'nowrap'
          }}
        >
          m
        </Typography>
      </Button>
      <Button 
        className={unit === "yards" ? "active" : ""}
        onClick={() => onToggle("yards")}
      >
        <Typography 
          style={{
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: '25px',
            whiteSpace: 'nowrap'
          }}
        >
          yd
        </Typography>
      </Button>
    </ButtonGroup>
  );
});

UnitToggle.displayName = 'UnitToggle';

export default UnitToggle; 